import React from 'react'
import { compose, withPropsOnChange, } from 'recompose'
import EquipmentWidget from '@infotech/equipment-widget'
import { Modal, modalEnhancer, } from '@infotech/base-components'
import { PrimaryButton } from '@infotech/uikit-button'

import equipmentDependencies from './equipmentDependencies'

import './equipment.css'

const ToggleComponent = ({ onToggle }) => (
  <PrimaryButton
    onClick={onToggle}
    type="button"
  >
    Добавить оборудование
  </PrimaryButton>
)

const HeaderComponent = () => `Добавить оборудование`

const WrapperComponent = ({ children }) => (
  <div className="equipment-field-widget">
    { children }
  </div>
)

const EquipmentWidgetModalComponent = ({
  isOpen, onToggle, input, dependencies,
}) => (<>
  <div className="pb-3">
    {Array.isArray(input.value) && input.value.map(v => v.value).join(', ')}
  </div>
  <Modal
    toggleComponent={ToggleComponent}
    headerComponent={HeaderComponent}
    wrapperComponent={WrapperComponent}
    isOpen={isOpen}
    onToggle={onToggle}
    modalClassName="equipment-field-widget-modal"
  >
    <EquipmentWidget
      dependencies={dependencies}
      input={input}
    />
  </Modal>
</>)

const EquipmentWidgetModal = compose(
  modalEnhancer,
  withPropsOnChange([`onToggle`], ({ onToggle }) => ({
    dependencies: {
      ...equipmentDependencies,
      onToggleWidget: onToggle,
    },
  })),
)(EquipmentWidgetModalComponent)

export default EquipmentWidgetModal
